import React, { Component } from "react"
import { Button } from "reactstrap"
import MetamaskLogo from "../assets/images/metamask.png"
import { setNetwork, setNetworkOption, setLogin } from "../store/common/commonActions"
import { KNOWN_CHAINS } from "../libs/useMetaMaskWallet/utils.js"
import { connect } from "react-redux"

import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogActions from "@material-ui/core/DialogActions"
import Dialog from "@material-ui/core/Dialog"

class ConnectWallet extends Component {
    constructor(props) {
        super(props)
        this.state = { wallet_error: "", chain_error: "" }
    }

    handleConnect = async () => {
        this.props.setNetworkOption("")
        this.props.setNetwork("Metamask")
        try {
            await this.props.wallet.connect()
            if (this.props.wallet.error) {
                this.setState({ wallet_error: this.props.wallet.error.message })
            } else if (this.props.chainId && this.props.chainId !== this.props.wallet.chainId) {
                this.setState({
                    chain_error: `Sorry you are not connected to ${KNOWN_CHAINS[this.props.chainId]}, please change your network.`
                })
            } else {
                this.props.onChange(true)
                this.props.setLogin(true)
            }
        } catch (error) {
            console.error(error)
            this.props.setNetworkOption("Ethereum")
            if (error.name === "ChainUnsupportedError") {
                this.setState({
                    chain_error:
                        "Sorry, selected network is not supported! Please change your network to any of the following: " +
                        "zkSync Era Mainnet, Eth Mainnet, Polygon"
                })
            } else {
                this.setState({ wallet_error: String(error) })
            }
        }
    }

    disconnectWallet = () => {
        this.props.setLogin(false)
        this.props.wallet.reset()
    }

    goToInstallMetaMaskPage = () => {
        this.setState({ wallet_error: "" })
        window.open("https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn", "_blank")
    }

    render() {
        return (
            <React.Fragment>
                {this.props.chainId && this.props.chainId !== this.props.wallet.chainId && this.props.wallet.account ? (
                    <div className="d-flex flex-column text-center justify-content-center align-items-center py-5">
                        <div className="metamask_logo">
                            <img src={MetamaskLogo} alt="metamask" style={{ width: 150 }} />
                        </div>
                        <h1 className="mt-4">Connect Wallet to {KNOWN_CHAINS[this.props.chainId]}</h1>
                        <p>
                            You currently connected to {KNOWN_CHAINS[this.props.wallet.chainId]}.
                            <br />
                            Please try to disconnect and connect to {KNOWN_CHAINS[this.props.chainId]}.
                        </p>
                        <Button color="primary" className="waves-effect waves-light" style={{ width: 200 }} onClick={this.disconnectWallet}>
                            Disconnect
                        </Button>
                    </div>
                ) : (
                    <div className="d-flex flex-column text-center justify-content-center align-items-center py-5">
                        <div className="metamask_logo">
                            <img src={MetamaskLogo} alt="metamask" style={{ width: 150 }} />
                        </div>
                        <h1 className="mt-4">Connect Wallet</h1>
                        <p>
                            Connecting you to zkSync and the Decentralized Web.
                            <br />
                            We're happy to see you.
                        </p>
                        <Button
                            color="primary"
                            className="waves-effect waves-light"
                            style={{ width: 200, fontSize: "1rem" }}
                            onClick={this.handleConnect}
                        >
                            Connect
                        </Button>
                    </div>
                )}
                <Dialog
                    open={this.state.wallet_error}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="sm"
                    fullWidth
                    onClose={() => this.setState({ wallet_error: "" })}
                >
                    <DialogTitle id="alert-dialog-title">Install MetaMask</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">Please install MetaMask wallet on your browser to connect</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" autoFocus onClick={this.goToInstallMetaMaskPage}>
                            Install MetaMask
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.chain_error}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="sm"
                    fullWidth
                    onClose={(event, reason) => {
                        if (reason === "onBackdropClick") {
                            this.setState({ chain_error: "" })
                        }
                    }}
                >
                    <DialogTitle id="alert-dialog-title">MetaMask Network</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">{this.state.chain_error}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" autoFocus onClick={() => this.setState({ chain_error: "" })}>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        )
    }
}

const mapDispatchToProps = {
    setLogin,
    setNetwork,
    setNetworkOption
}

export default connect(null, mapDispatchToProps)(ConnectWallet)
